import './index.css'
import './bootstrap'

import ReactDOM from 'react-dom'
import { StrictMode } from 'react'

import PackageJson from '../package.json'
import reportWebVitals from './reportWebVitals'

import App from './App'
import { AuthProvider } from './components/containers/AuthContainer'
import SentryContainer from './components/containers/SentryContainer'
import { SnackbarProvider } from './components/containers/SnackbarContainer'
import ReactQueryContainer from './components/containers/ReactQueryContainer'

console.log(`v${PackageJson.version}`)

ReactDOM.render(
  <StrictMode>
    <SentryContainer>
      <SnackbarProvider autoHideDuration={5000}>
        <ReactQueryContainer>
          <AuthProvider cookiePrefix="_llpweaut">
            <App />
          </AuthProvider>
        </ReactQueryContainer>
      </SnackbarProvider>
    </SentryContainer>
  </StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
